angular.module('login').run(['$templateCache', function($templateCache) {
  'use strict';

  $templateCache.put('/login/views/login.html',
    "﻿<div class=\"body\" ng-cloak>\r" +
    "\n" +
    "    <div id=\"login-container\" class=\"container-fluid\" ap-login-background client-Id=\"model.clientID\">\r" +
    "\n" +
    "        <div class=\"row\">\r" +
    "\n" +
    "            <div class=\"col-xs-12 col-xs-flush col-md-6 col-md-offset-3\">\r" +
    "\n" +
    "                <div id=\"login-header\" class=\"logo-group\">\r" +
    "\n" +
    "                    <div class=\"row\">&nbsp;</div>\r" +
    "\n" +
    "                    <div class=\"modal-dialog modal-dialog-login\">\r" +
    "\n" +
    "                        <div class=\"row\">\r" +
    "\n" +
    "                            <div class=\"col-xs-12 col-xs-flush col-md-10\">\r" +
    "\n" +
    "                                <div class=\"modal-content\">\r" +
    "\n" +
    "                                    <div class=\"modal-header\">\r" +
    "\n" +
    "                                        <div class=\"facility-portal text-center\">\r" +
    "\n" +
    "                                            <div class=\"login-facility-portal\">               \r" +
    "\n" +
    "                                                Facility P<em>o</em>rtal\r" +
    "\n" +
    "                                            </div>\r" +
    "\n" +
    "                                            <title>{{::'Login' | translate}}</title>\r" +
    "\n" +
    "                                            <div class=\"modal-subtitle\" id=\"myModalLabel2\" ng-if=\"model.practiceName\">\r" +
    "\n" +
    "                                                {{model.practiceName}}\r" +
    "\n" +
    "                                            </div>\r" +
    "\n" +
    "                                        </div>\r" +
    "\n" +
    "                                    </div>\r" +
    "\n" +
    "                                    <div class=\"modal-body\">\r" +
    "\n" +
    "                                        <form id=\"login-form\" name=\"loginForm\" ap-form-focus ng-submit=\"$ctrl.login()\"\r" +
    "\n" +
    "                                              novalidate>\r" +
    "\n" +
    "                                            <div ng-if=\"!$ctrl.selectUserMode\">\r" +
    "\n" +
    "                                                <div class=\"form-group\"\r" +
    "\n" +
    "                                                     ng-class=\"{ 'has-error' : loginForm.userName.$invalid && submitted}\">\r" +
    "\n" +
    "\r" +
    "\n" +
    "                                                    <label for=\"userName\">{{::'Username' | translate}}</label>\r" +
    "\n" +
    "\r" +
    "\n" +
    "                                                    <input type=\"text\" class=\"form-control\" name=\"userName\"\r" +
    "\n" +
    "                                                           ng-model=\"$ctrl.model.username\"\r" +
    "\n" +
    "                                                           placeholder=\"{{'Username' | translate}}\"\r" +
    "\n" +
    "                                                           id=\"userName\"\r" +
    "\n" +
    "                                                           ng-change=\"model.userId = null;\"\r" +
    "\n" +
    "                                                           required>\r" +
    "\n" +
    "\r" +
    "\n" +
    "                                                    <span ng-show=\"loginForm.userName.$invalid && submitted\"\r" +
    "\n" +
    "                                                          class=\"text-danger ng-hide\">\r" +
    "\n" +
    "                                                        {{::'Not valid.' | translate}}\r" +
    "\n" +
    "                                                    </span>\r" +
    "\n" +
    "                                                </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "                                                <div class=\"form-group\"\r" +
    "\n" +
    "                                                     ng-class=\"{ 'has-error' : loginForm.passwordInput.$invalid && submitted}\">\r" +
    "\n" +
    "                                                    <label for=\"passwordInput\">{{::'Password' | translate}}</label>\r" +
    "\n" +
    "\r" +
    "\n" +
    "                                                    <input type=\"password\" class=\"form-control\" name=\"passwordInput\"\r" +
    "\n" +
    "                                                           ng-model=\"$ctrl.model.password\"\r" +
    "\n" +
    "                                                           id=\"passwordInput\"\r" +
    "\n" +
    "                                                           placeholder=\"{{'Password' | translate}}\"\r" +
    "\n" +
    "                                                           required>\r" +
    "\n" +
    "                                                    <b class=\"tooltip tooltip-top-right\">\r" +
    "\n" +
    "                                                        <i class=\"fa fa-lock txt-color-teal\"></i>\r" +
    "\n" +
    "                                                        {{::'Enter your password' | translate}}\r" +
    "\n" +
    "                                                    </b>\r" +
    "\n" +
    "                                                    <span ng-show=\"loginForm.passwordInput.$invalid && submitted\"\r" +
    "\n" +
    "                                                          class=\"help-block ng-hide\">\r" +
    "\n" +
    "                                                        {{::'Not valid.' | translate}}\r" +
    "\n" +
    "                                                    </span>\r" +
    "\n" +
    "                                                </div>\r" +
    "\n" +
    "                                            </div>\r" +
    "\n" +
    "                                            <div ng-if=\"$ctrl.selectUserMode\">\r" +
    "\n" +
    "                                                <div class=\"form-group\">\r" +
    "\n" +
    "                                                    <label for=\"$ctrl.userOption\">{{::'Select User' | translate}}</label>\r" +
    "\n" +
    "                                                    <ap-select>\r" +
    "\n" +
    "                                                    <select class=\"form-control\" name=\"userOption\"\r" +
    "\n" +
    "                                                        ng-model=\"$ctrl.model.userId\"\r" +
    "\n" +
    "                                                        id=\"userOption\"\r" +
    "\n" +
    "                                                        placeholder=\"{{'Select User' | translate}}\"\r" +
    "\n" +
    "                                                        ng-options=\"user.UserId as (user.LastName + ', ' + user.FirstName) for user in $ctrl.userOptions\"\r" +
    "\n" +
    "                                                        ap-required=\"true\">\r" +
    "\n" +
    "                                                    </select>\r" +
    "\n" +
    "                                                    </ap-select>\r" +
    "\n" +
    "                                                    <span ng-show=\"form.password.$invalid && form.$submitted\"\r" +
    "\n" +
    "                                                        class=\"help-block ng-hide\">\r" +
    "\n" +
    "                                                        {{::'Not valid.' | translate}}\r" +
    "\n" +
    "                                                    </span>\r" +
    "\n" +
    "                                                </div>\r" +
    "\n" +
    "                                                <div class=\"text-left\">\r" +
    "\n" +
    "                                                    <span translate>\r" +
    "\n" +
    "                                                        Your login is associated with multiple users. Please select the user you would like to login as.\r" +
    "\n" +
    "                                                    </span>\r" +
    "\n" +
    "                                                </div>\r" +
    "\n" +
    "                                            </div>   \r" +
    "\n" +
    "                                            <div class=\"text-center\">\r" +
    "\n" +
    "                                                <span class=\"text-danger ng-hide\"\r" +
    "\n" +
    "                                                      ng-show=\"loginForm.passwordInput.$invalid && submitted\">\r" +
    "\n" +
    "                                                    {{::'Login could not be completed.' | translate}}\r" +
    "\n" +
    "                                                </span>\r" +
    "\n" +
    "\r" +
    "\n" +
    "                                                <div ng-show=\"$ctrl.errorMessage\" class=\"ng-hide\">\r" +
    "\n" +
    "                                                    <span class=\"text-danger keep-whitespace-line\">\r" +
    "\n" +
    "                                                        {{$ctrl.errorMessage | translate}}\r" +
    "\n" +
    "                                                    </span>\r" +
    "\n" +
    "                                                </div>\r" +
    "\n" +
    "                                            </div>\r" +
    "\n" +
    "                                            <div>\r" +
    "\n" +
    "                                                <button type=\"submit\" class=\"btn btn-primary btn-lg btn-block btn-login\"\r" +
    "\n" +
    "                                                        ng-disabled=\"$ctrl.loading\">\r" +
    "\n" +
    "                                                    <span class=\"ng-hide\" ng-show=\"$ctrl.loading\"><ap-spinner></ap-spinner></span>\r" +
    "\n" +
    "                                                    {{'Login' | translate}}\r" +
    "\n" +
    "                                                </button>\r" +
    "\n" +
    "                                            </div>\r" +
    "\n" +
    "                                        </form>\r" +
    "\n" +
    "                                    </div>\r" +
    "\n" +
    "                                </div>\r" +
    "\n" +
    "                            </div>\r" +
    "\n" +
    "                        </div>\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "        <!-- Below is a hack to get the android webview to behave properly while logging in.\r" +
    "\n" +
    "        If this is removed, it will cause random whitespace to appear after login.  Please don't remove. -->\r" +
    "\n" +
    "        <div class=\"row\" style=\"overflow: hidden; min-height: 1px;\">\r" +
    "\n" +
    "            <div class=\"col-xs-12 col-sm-10 col-sm-offset-1 col-md-6 col-md-offset-3\"\r" +
    "\n" +
    "                 style=\"margin-bottom: -99999px; padding-bottom: 99999px;\"></div>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "</div>\r" +
    "\n"
  );

}]);
